import { render, staticRenderFns } from "./yi-category.vue?vue&type=template&id=578ee0c7&"
import script from "./yi-category.vue?vue&type=script&lang=js&"
export * from "./yi-category.vue?vue&type=script&lang=js&"
import style0 from "./yi-category.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "src/components/yi-category/yi-category.vue"
export default component.exports